export default __webpack_public_path__ + "static/media/art2.902825bf.jpg";